import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { required } from '@validations'
import DocumentApis from '@/services/apis/document'
import CustomerWalletApis from '@/modules/crypto/services/apis/customer-wallet'
import { toEnglishDigits, numberWithCommas } from '@/utils/index'
import moment from 'moment'

const userDocument = new DocumentApis()
const customerWallet = new CustomerWalletApis()
export default {
  components: {
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      show: true,
      iban: '',
      ibans: [],
      currency: '',
      currencies: [],
      amount: '',
      required,
      submitLoading: false,
      alertShow: false,
      balance: '',
      token: '',
      helpers: {
        numberWithCommas,
      },
      showReceipt: false,
      items: [],
      page: 1,
      perPage: 10,
      total: 0,
    }
  },
  computed: {
    isUserExist() {
      return this.$store.state.auth.user?.id
    },
    fields() {
      return [
        {
          label: this.$t('currency'),
          key: 'currency.currency',
        },
        {
          label: this.$t('Network'),
          key: 'network',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('amount'),
          key: 'automation.amount',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('date'),
          key: 'created_at',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('status'),
          key: 'automation.status',
          tdClass: 'nameOfTheClass',
        },
        {
          label: this.$t('transaction_id'),
          key: 'transaction_id',
          tdClass: 'nameOfTheClass',
        },
      ]
    },
  },
  watch: {
    page(val) {
      if (val) {
        this.getWithdrawals()
      }
    },
  },
  mounted() {
    customerWallet.getUserWallets({ is_fiat: true }).then(res => {
      // eslint-disable-next-line prefer-destructuring
      this.currencies = res.data.results

      if (this.$route.params.token) {
        const [token] = res.data.results.filter(wallets => wallets.token === this.$route.params.token)
        this.token = token
        this.onchangeCurrency(token)
      }
      this.show = false
    }).catch(err => {
      console.log(err)
      this.show = false
    })
    this.getWithdrawals()
  },
  methods: {
    getFormattedDate(date) {
      return moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    async showModal() {
      const valid = await this.$refs.simpleRules.validate()
      if (valid) {
        this.$bvModal.show('modal-scoped')
        this.showReceipt = true
      }
    },
    numberFormat(value) {
      this.points = Number(value.replace(/\D/g, ''))
      return this.points.toLocaleString()
    },
    submit() {
      this.$bvModal.hide('modal-scoped')
      this.submitLoading = true
      customerWallet.storeWithdraw({
        currency: this.token.token,
        amount: toEnglishDigits(this.amount.replace(/,/g, '')),
        bank_id: this.iban.id,
      }).then(res => {
        this.$swal({
          title: res.data.message,
          icon: 'success',
          timer: 2500,
          showConfirmButton: false,
        })
        this.alertShow = true
        this.showReceipt = false
      }).catch(err => {
        console.log(err)
      }).finally(() => {
        this.submitLoading = false
      })
    },
    getWithdrawals() {
      this.show = true
      customerWallet.getWithdrawals({
        currency: this.token.token,
        page: this.page,
        per_page: this.perPage,
      }).then(res => {
        // eslint-disable-next-line prefer-destructuring
        this.items = res.data.results.data
        this.total = res.data.results.paginate.total
      }).finally(() => {
        this.show = false
      })
    },
    async onchangeCurrency(item) {
      this.show = true
      this.iban = ''
      this.balance = `${item.quantity} ${item.token}`
      await userDocument.getDocumentBankInfo({ status: 'success', currency: item.token }).then(res => {
        this.ibans = res.data.results
      }).finally(() => {
        this.show = false
      })
    },
  },
}
